import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from 'src/app/services/authentication/login.service';
import { ApiService } from 'src/app/services/main/api.service';
import { GlobalService } from 'src/app/services/main/global.service';
import { environment } from 'src/environments/environment';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { Storage } from '@ionic/storage';
import Swal from 'sweetalert2';
import {FormGroup} from "@angular/forms";
import {NgxImageCompressService} from "ngx-image-compress";

const GET_ALL_SITES_ACTIVE = environment.Global.API_GET_ALL_SITES_ACTIVE;
const API_USER_SYSTEM_GET_ALL = environment.Global.API_USER_SYSTEM_GET_ALL;
const API_GET_EMPLOYEE_INTERNAL_ALL = environment.Global.API_GET_EMPLOYEE_INTERNAL_ALL;
const API_USER_SYSTEM_UPDATE = environment.Global.API_USER_SYSTEM_UPDATE;

@Component({
  selector: 'app-maintuser',
  templateUrl: './maintuser.component.html',
  styleUrls: ['./maintuser.component.css']
})
export class MaintuserComponent extends BaseCrudComponent implements OnInit {
  row_plantas = [];
  userinfo:any;
  listUsers = [];
  listEmployees = [];
  empleados = [];
  defaultSignature:any ;
  selectedFile: File | null = null;
  imagePreviewUrl: string | null = null;
  fileSizeLimit = 10 * 1024 * 1024; // 10MB en bytes
  allowedFileTypes = ['image/png', 'image/jpeg'];
  fileSizeError: string | null = null;
  fileTypeError: string | null = null;
  // userinfo: any;

  foto64;
  imageSrc: any;
  fields: any;
  curr_parameter: any;
  form: FormGroup;
  valid = false;
  max_img_count:number =1
  max_img_size: number = 1;
  max_img_size2: number = 1;
  im: any = {img:[]};

  constructor(
    srv: ApiService,
    modalService: NgbModal,
    storage: Storage,
    router: Router,
    private globalService: GlobalService,
    private route: ActivatedRoute,
    public auth: LoginService,
    public translate: TranslateService,
    private imageCompress: NgxImageCompressService
  ) {
    super(srv, modalService, storage, router);
  }

  async ngOnInit() {
    await this.translate.getTranslation(this.translate.currentLang)
      .toPromise().then((translations) => {
        this.translations = translations;
        super.ngOnInit();
      });
    this.pageSize = 8;
    this.search_fields = ['UserId','Username','Email','FirstName','LastName'];
    await this.storage.get('userinfo').then(x => {
      this.userinfo = x;
    });
    await this.getList();
  }

  public async getList() {
    this.loadingList = true;
    let url = API_USER_SYSTEM_GET_ALL;
    await this.srv.getCall(url).toPromise().then(x => {
      this.loadingList = false;
      if(x.success){
        if(x.val != null){
          var rs = x.val;
          this.rawdata = x.val;
          this.rows = rs;
          this.listUsers = x.val;
          this.page = 1;
          if( Array.isArray(this.rows) ){
            this.pageTotal = this.rows.length;
          }
          this.filterAll();
        }else {
          this.rows = [];
          return;
        }
      }else {
        this.rows = [];
        return;
      }
    });
  }


  public async openUpdateModal(modal, row) {
    this.defaultSignature = '../../../assets/images/users/signature.png';
    this.u_obj = row;
    this.u_obj['name_last_name'] = row.FirstName + " " + row.LastName;

    this.modalService.open(modal, { backdrop: 'static',  keyboard : false, windowClass:"myCustomModalClass"});
    this.GetPlantas();
    this.empleados = [];
    await this.getEmployees();
  }

  onFileSelected(e: any, obj:any): void {
    this.selectedFile = e.target.files[0];
    this.imagePreviewUrl = null; // Limpiar la vista previa anterior
    this.fileSizeError = null;
    this.fileTypeError = null;

    if (this.selectedFile) {
      if (this.selectedFile.size > this.fileSizeLimit) {
        this.fileSizeError = 'El archivo excede el tamaño máximo de 10MB.';
        this.selectedFile = null;
        Swal.fire(this.fileSizeError, '', 'error');
        return;
      }

      if (!this.allowedFileTypes.includes(this.selectedFile.type)) {
        this.fileTypeError = 'Solo se permiten archivos con extensiones .png, .jpeg o .gif.';
        this.selectedFile = null;
        Swal.fire(this.fileTypeError, '', 'error');
        return;
      }

      // Previsualizar la imagen
      var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
      var pattern = /image-*/;
      var reader = new FileReader();
      // reader.onload = () => {
      //   this.imagePreviewUrl = reader.result as string;
      // };
      // reader.readAsDataURL(this.selectedFile);
      // }
      reader.onload = (_event) => {
        console.log('Imagen cargada:', file.name, 'Tamaño:', file.size);
        // if ((obj.img.length + 1) > this.max_img_count) {
        //   Swal.fire(this.translations.pdi_max_img_count + ' ' + this.max_img_count, '', 'success');
        // } else {
        this.compressFile(reader.result, file.name).then(x => {
          if (x != false) {
            var aux: unknown = '';
            this.compressImage(x, 300, 300).then(compressed => {
              aux = compressed;
              console.log('PROBANDO Imágenes actuales en el objeto:', obj.img);
              obj.img.push({src: aux, obj: undefined, fname: file.name, imId: Date.now(), comment: ''});
              console.log('PROBANDO Imágenes actuales en el objeto:', obj.img);
              // const str = reader.result.toString();
              this.foto64 = aux;
              if (this.u_obj['signature'] == null) {
                this.u_obj['signature'] = this.foto64;
              }else {
                this.u_obj['signature'] = this.foto64;
              }
              this.imageSrc = aux;
              this.defaultSignature = null;
            })
          } else {
            Swal.fire(this.translations.pdi_img_toobig, '', 'warning');
            this.foto64 = aux;
            if (this.u_obj['signature'] == null) {
              this.u_obj['signature'] = this.foto64;
            }
            this.imageSrc = aux;
            this.defaultSignature = null;
          }
        });
        // }
      }
      reader.readAsDataURL(file);
    }
  }

  compressFile(image,fileName) {
    var orientation = -1;
    let sizeOfOriginalImage = this.imageCompress.byteCount(image)/(1024*1024);

    if( sizeOfOriginalImage > this.max_img_size2 ) {
      console.log('with conversion');
      return this.imageCompress.compressFile(image, orientation, 50, 50).then(
        result => {
          let sizeOFCompressedImage = this.imageCompress.byteCount(result)/(1024*1024);
          console.log('Size in Mbytes after compression:',  sizeOFCompressedImage);
          if( sizeOFCompressedImage > this.max_img_size ){
            return false;
          }
          else{
            return result;
          }
        });
    }
    else{
      console.log('no conversion');
      return new Promise(function(resolve, reject) { resolve(image) });
    }
  }

  compressImage(src, newX, newY) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');
        elem.width = newX;
        elem.height = newY;
        elem.toBlob((blob)=>{
          const  myImage = new File([blob],'file.webp',{type:blob.type});
        }, 'image/webp');

        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, newX, newY);

        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => rej(error);
    });
  }
  public updateItem(modal) {
    this.isUpdating = true;
    let url = API_USER_SYSTEM_UPDATE;
    let codeEmployee = "";
    if (this.empleados.length > 0) {
      codeEmployee = this.empleados.toString()
    } else {
      codeEmployee = null;
    }
    let new_obj= {
      UserId : this.u_obj['UserId'],
      PlantaId : this.u_obj['PlantaId'],
      EmployeeId : codeEmployee,
      signature : this.foto64,
      ApproveART : this.u_obj['ApproveART'],
    }

    // console.log(new_obj)

    this.srv.postCall(url, new_obj).subscribe(data => {
      if (data.success) {
        this.isUpdating = false;
        Swal.fire(this.translations.msg_update, '', 'success');
        this.u_obj = {};
        this.empleados = [];
        this.getList();
        this.closeModal(modal)
      }
    },catchError =>{
      this.isUpdating = false;
      Swal.fire(catchError.message, '', 'error');
    });
  }
  public async getEmployees() {
    let url = API_GET_EMPLOYEE_INTERNAL_ALL;
    await this.srv.getCall(url).toPromise().then(x => {
      if(x.success){
        if(x.val != null){
          this.listEmployees = x.val;
          let lista = []
          if ( this.u_obj['EmployeeId'] != null) { // no tiene empleado
            if (this.u_obj['EmployeeId'].includes(',')) {
              lista = this.u_obj['EmployeeId'].split(',');
            } else {
              lista = [this.u_obj['EmployeeId']];
            }
            let l = [];
            this.listEmployees.forEach( empleado => {
              if (lista.includes((empleado.EmployeeId).toString())) {
                l.push(empleado.EmployeeId);
              }
            })
            this.empleados = l;
          }
        }else {
          this.listEmployees = [];
          return;
        }
      }else {
        this.listEmployees = [];
        return;
      }
    });
  }


  public GetPlantas() {
    var qst = GET_ALL_SITES_ACTIVE;
    // console.log(qst)
    this.srv.getCall(qst).subscribe(x => {
      this.row_plantas = [];
      if(x.success){
        if(x.val != null){
          var rs = x.val;
          this.row_plantas = rs;
        } else {
          this.row_plantas = [];
          return;
        }
      } else {
        return;
      }
    });
  }


  saveImage(): void {
    if (this.selectedFile) {
      // Aquí puedes implementar la lógica para guardar la imagen,
      this.isUpdating = true;
      var qst = '';//API_POSTUSERSIGNATURE;
      // por ejemplo, enviándola a un servicio backend.
      var to: any;
      to = {};
      to.UserIdAquasym = this.userinfo['userId'];
      to.signature = this.foto64;
      console.log('Archivo seleccionado para guardar:',to);
      this.srv.postCall(qst, to).subscribe(x => {
        this.isUpdating = false;
        if (x.success) {
          this.reload.next(true);
          // this.closeModal('update1');
          Swal.fire(this.translations.msg_update, x.msg, 'success');
          this.getList();
        }
      }, err => {
        Swal.close();
        Swal.fire('Error');
      });
    } else {
      alert('Por favor, selecciona una imagen primero.');
    }
  }
}
